"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ActionTypes"));

var _RequestStatusTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/RequestStatusTypes"));

var initialState = null;

var Merchandise = function Merchandise() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.default.MERCHANDISE_RECEIVED:
      return payload;

    case _ActionTypes.default.MERCHANDISE_FAILED:
      return _RequestStatusTypes.default.FAILED;

    default:
      return state;
  }
};

var _default = Merchandise;
exports.default = _default;
module.exports = exports.default;